import { render, staticRenderFns } from "./ModalAnswersRejectedVideo.vue?vue&type=template&id=32577efa"
import script from "./ModalAnswersRejectedVideo.vue?vue&type=script&lang=js"
export * from "./ModalAnswersRejectedVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports